import { render, staticRenderFns } from "./Misc.vue?vue&type=template&id=1b0d9504&scoped=true"
import script from "./Misc.vue?vue&type=script&lang=ts"
export * from "./Misc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0d9504",
  null
  
)

export default component.exports